import { GroupCustomSegmentNode } from '@libs/src/models/group.model';

import findIndex from 'lodash-es/findIndex';
import includes from 'lodash-es/includes';
import isEqual from 'lodash-es/isEqual';
import isUndefined from 'lodash-es/isUndefined';
import sortBy from 'lodash-es/sortBy';

export function generateEdgeUpdates(options: {
  targetNode: GroupCustomSegmentNode;
  currentEdges: string[][];
  updateEdges: string[][];
}) {
  const targetCurrentEdges = options.currentEdges.filter((edge: string[]) =>
    includes(edge, options.targetNode.name),
  );
  return {
    delete: targetCurrentEdges.filter((item) => {
      return options.updateEdges.every((updateEdge) => {
        return !isEqual(sortBy(updateEdge), sortBy(item));
      });
    }),
    put: options.updateEdges.filter((edge: string[]) => {
      return targetCurrentEdges.every((currentEdge: string[]) => {
        return !isEqual(sortBy(currentEdge), sortBy(edge));
      });
    }),
  };
}

export function generateNodesPerEdge(options: {
  edges: string[][];
  nodes: GroupCustomSegmentNode[];
}) {
  return options.nodes.reduce((result, node) => {
    return {
      ...result,
      [node.name]: options.edges
        .filter((edge: string[]) => includes(edge, node.name))
        .map((edge: string[]) => {
          const targetIndex =
            0 === findIndex(edge, (item) => item === node.name) ? 1 : 0;
          return edge[targetIndex];
        })
        .map((nodeName: string) =>
          options.nodes.find((item: GroupCustomSegmentNode) =>
            isEqual(item.name, nodeName),
          ),
        )
        .filter((edge) => !isUndefined(edge)),
    };
  }, {}) as { [nodeName: string]: GroupCustomSegmentNode[] };
}

export function generateEdges(options: {
  node: GroupCustomSegmentNode;
  nodesToMakeEdgesWith: GroupCustomSegmentNode[];
}) {
  return options.nodesToMakeEdgesWith.map((item) => {
    return [options.node.name, item.name];
  });
}
